import {
	FaBars,
	FaHeart,
	FaComment,
	FaMoneyBill,
	FaPaperPlane,
	FaInfoCircle,
} from "react-icons/fa";

import {
	Box,
	Menu,
	Flex,
	Button,
	Heading,
	MenuList,
	IconButton,
	MenuButton,
} from "@chakra-ui/react";

import { MobileNavButton } from "./MobNavButton";

export const MobileNav = () => {
	return (
		<Box>
			<Menu>
				<Flex
					py="2"
					px="4"
					gap="1"
					left="0"
					w="100%"
					zIndex={9}
					align="center"
					position="fixed"
					justify="flex-start"
				>
					<MenuButton
						size="sm"
						fontSize="2xl"
						variant="unstyled"
						aria-label="Menu"
						_hover={{ color: "brand.contrast" }}
						icon={<FaBars />}
						as={IconButton}
					/>

					<Button
						variant="unstyled"
						onClick={() => window.location.replace("/#")}
						_hover={{ color: "brand.contrast" }}
					>
						<Heading fontSize="2xl">LULU</Heading>
					</Button>
				</Flex>

				<MenuList borderColor="brand.dark">
					<MobileNavButton
						label="experience"
						route="experience"
						icon={<FaHeart />}
					/>
					<MobileNavButton
						label="compensation"
						route="compensation"
						icon={<FaMoneyBill />}
					/>
					<MobileNavButton
						label="booking info"
						route="faqs"
						icon={<FaInfoCircle />}
					/>
					<MobileNavButton
						label="testimonials"
						route="testimonials"
						icon={<FaComment />}
					/>
					<MobileNavButton
						label="get in touch"
						route="contact"
						icon={<FaPaperPlane />}
					/>
				</MenuList>
			</Menu>
		</Box>
	);
};
